import { useEffect, useState } from 'react'
import moment from 'moment'

import Porlet from '../../components/Porlet/Porlet'
import Filter from '../../components/Filter/Filter'

import getOperations from '../../services/operations/operations'

import styles from './Home.module.css'

const Home = () => {

  const [ yearSelect, setYearSelect ] = useState(moment().year())
  const [ data, setData ] = useState([])
  const [ dataFiltered, setDataFiltered ] = useState([])
  const [ pending, setPending ] = useState(false)

  useEffect(() => {
    setPending(true)
    getOperations(yearSelect)
    .then(data => {
      setData(data)
      setDataFiltered(data)
    })
    setPending(false)
  },[yearSelect])

  let datesInfo_static = [
    {
      name: "Nº Tasques Totals",
      data: data.numTasksTotals || 0,
      link: "/tasques",
      type: "info_static",
      icon: "fa-screwdriver-wrench"
    },
    {
      name: "Nº Tasques Planificades",
      data: data.numTasksNoRealitzats || 0,
      link: "/tasques",
      type: "info_static",
      icon: "fa-screwdriver-wrench"
    },
    {
      name: "Nº Tasques Realitzades",
      data: data.numTasksRealitzats || 0,
      link: "/tasques",
      type: "info_static",
      icon: "fa-screwdriver-wrench"
    },
    {
      name: "Nº Professionals",
      data: data.numProfessionals || 0,
      link: "/professionals",
      type: "info_static",
      icon: "fa-users"
    },
  ]

  let datesInfo_dinamic = [
    {
      name: "Nº Tasques Àrea",
      data: data.numTasksPlanificats || 0,
      link: "/tasques",
      type: "info",
      icon: "fa-screwdriver-wrench"
    },
    {
      name: "Nº Tasques Àrea Planificades",
      data: data.numTasksNoRealitzatsSelectet || 0,
      link: "/tasques",
      type: "info",
      icon: "fa-check-to-slot"
    },
    {
      name: "Nº Tasques Àrea Realitzades",
      data: data.numTasksRealitzatsSelectet || 0,
      link: "/tasques",
      type: "info",
      icon: "fa-check-to-slot"
    },
    {
      name: "Nº Tasques Àrea Endarrerides",
      data: data.numTasksEnderrarides || 0,
      link: "/tasques",
      type: "alerta",
      icon: "fa-clipboard",
      filter: true
    },
  ]

  let datesInfoUser_dinamic = [
    {
      name: "Nº Tasques",
      data: data.numTasksPlanificatsUser || 0,
      link: "/tasques",
      type: "info",
      icon: "fa-screwdriver-wrench"
    },
    {
      name: "Nº Tasques Planificades",
      data: data.numTasksNoRealitzatsSelectetUser || 0,
      link: "/tasques",
      type: "info",
      icon: "fa-check-to-slot"
    },
    {
      name: "Nº Tasques Realitzades",
      data: data.numTasksRealitzatsSelectetUser || 0,
      link: "/tasques",
      type: "info",
      icon: "fa-check-to-slot"
    },
    {
      name: "Nº Tasques Endarrerides",
      data: data.numTasksEnderraridesUser || 0,
      link: "/tasques",
      type: "alerta",
      icon: "fa-clipboard",
      filter: true
    },
  ]

  // Función para hacer funcionar el filtro de elementos => por any
    const handleChangeYears = (value) => {
      setYearSelect(value)
  }

  // Placeholder del filtro de any
  const placeholderFilterYears = "Filtre any"

  // Array con los elementos del filtro de any
  const years = [ 2025, 2026, 2027, 2028, 2029, 2030 ]
  const dataYears = years.map(element => {
      return {
          label: element,
          value: element
      }
  })

  return (
    <div className={styles.container_home}>
      <div className={styles.user_info}>
        <div className={styles.filter_year}>
            <Filter
                handleChange={handleChangeYears}
                data={dataYears} 
                placeholderFilter={placeholderFilterYears}
                value={moment().year()}
                type="single"
            />
        </div>
      </div>
      <div className={styles.container_line}>
        {
          datesInfo_static.map((element, index) => {
            return <Porlet key={index} data={pending ? pending : element.data } name={element.name} className={styles.portlet} link={element.link} type={element.type} icon={element.icon} filter={element.filter}></Porlet>
          })
        }
      </div>
      <div className={styles.container_line}>
        {
          datesInfo_dinamic.map((element, index) => {
            return <Porlet key={index} data={pending ? pending : element.data } name={element.name} className={styles.portlet} link={element.link} type={element.type} icon={element.icon} filter={element.filter}></Porlet>
          })
        }
      </div>
      <div className={styles.container_line}>
        {
          datesInfoUser_dinamic.map((element, index) => {
            return <Porlet key={index} data={pending ? pending : element.data } name={element.name} className={styles.portlet} link={element.link} type={element.type} icon={element.icon} filter={element.filter}></Porlet>
          })
        }
      </div>
    </div>
  )
}

export default Home